import React from 'react';
import { Route } from 'react-router-dom';
import { graphql, compose } from 'react-apollo';

import GetChannelQuery from 'GraphQueries/Channels/GetQuery';
import UpdateChannelMutation from 'GraphQueries/Channels/UpdateMutation';

import PageNavigationTabs from 'Components/Presentation/_Shared/Layout/PageNavigationTabs';

import ChannelEdit from 'Components/Presentation/Channels/ChannelEdit';

class ChannelEditContainer extends React.Component {

    static defaultProps = { 
        channel: { name: '' },
        loading: false,
        pageTabs: [
            { label: 'Back To List', path: 'list', includeId: false },
            { label: 'Settings', path: 'manage/settings', includeId: true },
        ]
    }

    state = { 
        activeTabIndex: 1, 
        saving: false 
    }

    tabClickHandler = (el, key) => {
        const { history, match: { params } } = this.props;
        history.push(el.includeId ?
            `/data-classifications/channels/${params.id}/${el.path}` :
            `/data-classifications/channels/${el.path}`);
        this.setState({ activeTabIndex: key });
    }

    setActiveTab = index => {
        this.setState({ activeTabIndex: index });
    }

    navigateWithData = (uri) => {
        const { history } = this.props;
        history.push(uri);
    }

    saveChannel = async (channel) => {
        const { onAlert, onUpdate } = this.props;
        this.setState({ saving: true });

        delete channel.__typename;

        onUpdate(channel).then(x => {
            this.setState({ saving: false });
            onAlert('success', `Successfully updated channel: ${channel.id}`);
        }).catch(error => {
            if(error.graphQLErrors) {
                error.graphQLErrors.map(({ message }, i) => {
                    if (message.match(/not authorized/gi)) {
                        onAlert('error', 'You are not authorised to update channels, please see a System Admin');
                    }
                    else { onAlert('error', message); }                    
                });                
            }
            this.setState({ saving: false });
        })
    }

    render() {
        const { channel, loading, pageTabs } = this.props;
        const { activeTabIndex, saving } = this.state;
        return (
            <React.Fragment>
                <PageNavigationTabs pageTabs={pageTabs} activeTabIndex={activeTabIndex} onTabClick={this.tabClickHandler} />
                <Route path="/data-classifications/channels/:id/manage/settings" render={props =>
                    <ChannelEdit channel={channel} loading={loading || saving} onChannelUpdated={this.saveChannel} onActivate={event => this.setActiveTab(1)} />} />
            </React.Fragment>
        );
    }
}

export default
    compose(
        graphql(GetChannelQuery, {
            options: ({ match: { params: { id } } }) => ({ variables: { id } }),
            props: ({ data: { getChannel, loading } }) => ({ channel: getChannel, loading })
        }),
        graphql(UpdateChannelMutation(), { props: ({ mutate }) => ({ onUpdate: input => mutate({ variables: { input } }) }) })
    )(ChannelEditContainer);


// WEBPACK FOOTER //
// ./src/Components/Containers/Channels/Edit.js